module.exports = __webpack_public_path__ + "img/filters.2481fce7.svg";